import {DocumentProcessingStatus, DocumentStatus} from '../../core/dictionaries';
import {UserRole} from '../../types/auth';
import {$profile} from '../utils';

const ROLES_DIRECTORS: UserRole[] = ['CHIEF_INSPECTOR', 'INSPECTOR', 'OPERATOR'];

const ROLES_EMPLOYEES: UserRole[] = ['DIRECTOR', 'EMPLOYEE'];

const ROLES_ALL = [...ROLES_DIRECTORS, ...ROLES_EMPLOYEES];

type SideFilter = 'OUTGOING' | 'INCOMING' | 'BOTH';
type RoleFilter = 'employees' | 'allRoles';

interface PermissionRule {
    sides: SideFilter;
    roles: RoleFilter;
    processingStatus?: DocumentProcessingStatus[];
}

type PermissionAction = 'create' | 'read' | 'edit' | 'accept' | 'reject' | 'cancel';

const PERMISSION_RULES: Record<
    PermissionAction,
    Partial<Record<DocumentStatus, PermissionRule>>
> = {
    create: {
        [DocumentStatus.NEW]: {
            sides: 'OUTGOING',
            roles: 'employees',
            processingStatus: [DocumentProcessingStatus.CREATED],
        },
    },
    read: {
        [DocumentStatus.NEW]: {sides: 'BOTH', roles: 'allRoles'},
        [DocumentStatus.SENT]: {sides: 'BOTH', roles: 'allRoles'},
        [DocumentStatus.REJECTED]: {sides: 'BOTH', roles: 'allRoles'},
        [DocumentStatus.ACCEPTED]: {sides: 'BOTH', roles: 'allRoles'},
        [DocumentStatus.CORRECTED]: {sides: 'BOTH', roles: 'allRoles'},
        [DocumentStatus.CANCELED]: {sides: 'BOTH', roles: 'allRoles'},
    },
    edit: {
        [DocumentStatus.NEW]: {
            sides: 'OUTGOING',
            roles: 'employees',
            processingStatus: [DocumentProcessingStatus.APPROVED],
        },
        [DocumentStatus.REJECTED]: {
            sides: 'OUTGOING',
            roles: 'employees',
            processingStatus: [DocumentProcessingStatus.APPROVED],
        },
        [DocumentStatus.ACCEPTED]: {
            sides: 'OUTGOING',
            roles: 'employees',
            processingStatus: [DocumentProcessingStatus.APPROVED],
        },
        [DocumentStatus.AUTO_ACCEPTED]: {
            sides: 'OUTGOING',
            roles: 'employees',
            processingStatus: [DocumentProcessingStatus.APPROVED],
        },
    },
    accept: {
        [DocumentStatus.NEW]: {
            sides: 'INCOMING',
            roles: 'employees',
            processingStatus: [DocumentProcessingStatus.APPROVED],
        },
    },
    reject: {
        [DocumentStatus.NEW]: {
            sides: 'INCOMING',
            roles: 'employees',
            processingStatus: [DocumentProcessingStatus.APPROVED],
        },
    },
    cancel: {
        [DocumentStatus.SENT]: {
            sides: 'OUTGOING',
            roles: 'employees',
            processingStatus: [DocumentProcessingStatus.CREATED],
        },
        [DocumentStatus.NEW]: {
            sides: 'OUTGOING',
            roles: 'employees',
            processingStatus: [DocumentProcessingStatus.APPROVED],
        },
        [DocumentStatus.ACCEPTED]: {
            sides: 'OUTGOING',
            roles: 'employees',
            processingStatus: [DocumentProcessingStatus.APPROVED],
        },
    },
};
export function checkPermission(
    // status: DocumentStatus,
    // processingStatus: DocumentProcessingStatus,
    // side: 'OUTGOING' | 'INCOMING',
    // role: UserRoles,
    params: {
        status: DocumentStatus;
        side: 'OUTGOING' | 'INCOMING';
        role: UserRole;
        processingStatus: DocumentProcessingStatus;
    },
    action: PermissionAction,
): boolean {
    const rule = PERMISSION_RULES[action][params.status];
    if (!rule) return false;

    const sideOk = rule.sides === 'BOTH' || rule.sides === params.side;
    const roleOk =
        rule.roles === 'employees'
            ? ROLES_EMPLOYEES.includes(params.role)
            : ROLES_ALL.includes(params.role);
    const processingStatusOk = rule.processingStatus?.length
        ? rule.processingStatus.includes(params.processingStatus)
        : true;

    return sideOk && roleOk && processingStatusOk;
}
